<template>
  <div>
    <div class="title">{{ model.title }}</div>
    <div class="desContent">
      <img class="avatar" :src="model.avatarUrl">
      <div class="des">{{ model.nickName }}</div>
      <div class="createTime">{{ model.createTime }}</div>
    </div>
    <div class="content">{{ model.content }}</div>
    <div>
      <img :style="imageStyle" class="articleImg" :src="model.articleImg">
    </div>
  </div>
</template>

<script>
import api from '../utils/api'

export default {
  name: 'ArticleInfoPage',
  computed: {
    imgWidth: function () {
      return 100.0 * 670.0 / 750 + 'vw'
    },
    imgHeight: function () {
      return 300.0 * 100.0 / 750 + 'vw'
    }
  },
  data () {
    return {
      audio: [{
        title: '天空之城',
        artist: '哈哈',
        url: 'https://edu-guil-1010.oss-cn-beijing.aliyuncs.com/%E5%A4%A9%E7%A9%BA%E4%B9%8B%E5%9F%8E.m4a',
        pic: 'https://edu-guil-1010.oss-cn-beijing.aliyuncs.com/QQ%E5%9B%BE%E7%89%8720200713203148.jpg',

      }],
      music: {
        title: '天空之城',
        artist: '哈哈',
        url: 'https://edu-guil-1010.oss-cn-beijing.aliyuncs.com/%E5%A4%A9%E7%A9%BA%E4%B9%8B%E5%9F%8E.m4a',
        pic: 'https://edu-guil-1010.oss-cn-beijing.aliyuncs.com/QQ%E5%9B%BE%E7%89%8720200713203148.jpg',

      },

      imageStyle: {
        width: 100. * 670.0 / 750.0 + 'vw',
        height: 100. * 300.0 / 750.0 + 'vw'
      },
      model: {
        id: '',
        title: '',
        content: '',
        avatarUrl: '',
        articleImg: '',
        hasPay: true,
        nickName: '',
        createTime: ''
      }
    }
  },
  methods: {},
  mounted () {
    // todo 写死的,需要修改
    api.getArticleInfo(12).then((value) => this.model = value)
  }
}
</script>

<style scoped>
.title {
  font-size: 0.4rem;
  margin-left: .4rem;
  text-align: left;
  font-weight: 500
}

.avatar {
  margin-left: .4rem;
  border-radius: 30px;
  height: 30px;
  width: 30px
}

.des {
  font-size: 0.26rem;
  margin-left: .2rem;
  text-align: left;
  color: #333333;
}

.createTime {
  font-size: 0.20rem;
  margin-left: .2rem;
  text-align: left;
  color: #999999

}

.desContent {
  margin-top: .2rem;
  display: flex;
  align-items: center;
}


.content {
  margin-top: .4rem;
  text-align: left;
  margin-left: .4rem;
  margin-right: .4rem;
  font-size: 0.32rem;
  color: #333333;
  line-height: 1.7;
  white-space: pre-wrap;
}

.articleImg {
  margin-left: .4rem;
  margin-right: .4rem;
  object-fit: cover;
  margin-bottom: .4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleInfoPage.vue